import {ToadMensagemService} from './../../service/toad-mensagem.service';
import {FtaService} from './../../service/fta.service';
import {NgForm} from '@angular/forms';
import {
    Evento,
    EventoOperacao,
    Parametro,
    Operacao,
    ParametroEntradaOperacao,
    ParametroConteudo,
    FTA,
    Layout
} from './../../model/catalogo';
import {Component, OnInit, Output, OnChanges, EventEmitter, Input, ViewChild} from '@angular/core';
import {JQueryStatic} from 'jquery';
import {ValidacaoService} from './../../service/validacao.service';
import {WizardComponent} from 'angular-archwizard';
import {FiltrosDeLayout, ResultadoFiltroLayout} from '../../model/filtros';
import {GlobalService} from '../../service/global.service';
import {PesquisasFiltroApiService} from '../../service/api/pesquisas-filtro.api';
import {ModalService} from './../../service/modal.service';

declare var $: JQueryStatic;

@Component({
    selector: 'app-detalhe-evento-operacao',
    templateUrl: './detalhe-evento-operacao.component.html',
    styleUrls: ['./detalhe-evento-operacao.component.css'],
    providers: [ValidacaoService]
})
export class DetalheEventoOperacaoComponent implements OnInit {

    @Output() eventoOperacaoAdiconado = new EventEmitter();

    @Input() novoEventoOperacao: EventoOperacao;

    @Input() evento: Evento;

    @Input() fta: FTA;

    //salvar evento
    @Output() eventoAlterado = new EventEmitter();

    //cancelar evento
    @Output() eventoCancelado = new EventEmitter();

    //fta: FTA = new FTA();

    operacao: EventoOperacao = new EventoOperacao();

    parmOperacao: Parametro = new Parametro();

    resultadosLayout: ResultadoFiltroLayout = new ResultadoFiltroLayout();

    loading: boolean = false;

    resultado: Array<Operacao> = new Array<Operacao>();

    novaOperacao: Operacao = new Operacao();

    selecionaOperacao: Operacao = new Operacao();

    parametroEntradaOperacao: ParametroEntradaOperacao = new ParametroEntradaOperacao();

    loadingTablePrincipal: boolean = false;

    parmNome: string;

    nomeSubtipoDado: string;

    parametro: any;

    parmConteudo: string;

    novoParametroConteudo: ParametroConteudo = new ParametroConteudo();

    paramentoConteudo: string;

    parametroConteudoFixo: string;

    parametroConteudoArray: string;

    parametroConteudoTextoLivre: string;

    chaveComposta: any;

    listaParametroConteudo: Array<ParametroConteudo> = new Array<ParametroConteudo>();

    selecionado: ParametroEntradaOperacao = new ParametroEntradaOperacao();

    eventoSelecionado: boolean = false;

    cols: any[];

    ultimoId = 0;

    loadingConteudo: boolean = false;

    lista = [];

    isDisabled: boolean = false;

    validaCampo: boolean = false;

    caracteresInvalidos: string = '';

    parmTransmissao: Array<Parametro> = new Array<Parametro>();

    parametrosSelecionadosOperacao: any;

    contador = 0;


    constructor(
        private ftaService: FtaService,
        private messageService: ToadMensagemService,
        private validacaoService: ValidacaoService,
        public globalService: GlobalService,
        public pesquisaService: PesquisasFiltroApiService,
        private modalService: ModalService,
        @ViewChild(WizardComponent)
        public wizard: WizardComponent) {
    }

    ngOnInit() {

        $('[data-toggle="tooltip"]').tooltip();

        this.cols = [
            {field: 'nome', header: 'Nome'},
            {field: 'descricao', header: 'Descrição'},
            {field: 'nomeTipoDado', header: 'Tipo'},
            {field: 'nomeSubtipoDado', header: 'SubTipo'},
            {field: 'obrigatorio', header: 'Obrig.'},
            {field: 'conteudoPadrao', header: 'Conteúdo Padrão'}
        ];

        let filtros: Array<any> = new Array<any>();
        this.ftaService.filtraOperacao(filtros)
            .subscribe(
                listaItens => {
                    if (listaItens != null) {

                        let listaItensAux = [];
                        listaItensAux.push({
                            codTipoEstado: '',
                            codigo: '',
                            descricao: '',
                            nome: ' Selecione',
                            versao: ''
                        });

                        for (let i in listaItens) {
                            listaItens[i].nome = `${listaItens[i].nome.toLowerCase()} - v${listaItens[i].versao}`;
                            listaItensAux.push(listaItens[i]);
                        }

                        listaItensAux.sort(function (a, b) {
                            if (a.nome < b.nome) {
                                return -1;
                            }
                            if (a.nome > b.nome) {
                                return 1;
                            }
                            return 0;
                        });
                        this.resultado = listaItensAux;
                        this.loadingTablePrincipal = true;

                    }
                },
                erro => {
                    if (erro.status == 404) {
                        // erro
                    }
                }
            );
        this.filtrarLayouts();
    }

    filtrarLayouts() {
        let filtros: Array<any> = new Array<any>();
        this.pesquisaService.filtraOperacao(filtros);

        this.globalService.loading = true;
        // this.pesquisaService.mudarPagina(this.pagina);
        // this.pesquisaService.filtraLayout(this.getFiltros())
        this.pesquisaService.filtraLayoutPaginado(this.getFiltros())
            .subscribe(
                listaItens => {
                    this.globalService.loading = false;
                    this.resultadosLayout = listaItens as ResultadoFiltroLayout;
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404) {
                        this.resultadosLayout.layouts = new Array<Layout>();
                    }
                    this.globalService.loading = false;
                }
            );
    }


    getFiltros() {
        let filtros = new FiltrosDeLayout();
        // let filtroLayout = new FiltroLayout();
        // let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        // let filtroMetadata = new FiltroMetadata();

        // filtroMetadata.pagina = this.pagina;
        // filtroMetadata.porPagina = 100;

        // filtros.filtroLayout = filtroLayout;
        // filtros.filtroAlteracaoEstado = filtroAlteracaoEstado
        // filtros.metadata = filtroMetadata

        return filtros;
    }

    definirLayoutArquivo() {
        for (let i = 0; i <= this.resultadosLayout.layouts.length; i++) {
            if (this.resultadosLayout.layouts[i]) {
                if (this.resultadosLayout.layouts[i].codigo == this.operacao.codLayout) {
                    this.operacao.codLayout = this.resultadosLayout.layouts[i].codigo;
                    this.operacao.vrsLayout = this.resultadosLayout.layouts[i].versao;
                    this.operacao.nomeLayout = this.resultadosLayout.layouts[i].nome;
                }
            }
        }

        this.salvarDadosOperacao();
    }

    ngOnChanges() {
        if (this.novoEventoOperacao != undefined) {
            this.operacao = new EventoOperacao();
            this.operacao = this.novoEventoOperacao;
            if (this.operacao.parmOperacao.length > 0) {
                this.loading = true;

                //ajusta operacao na edicao
                for (let i in this.resultado) {
                    if (this.resultado[i].codigo === this.novoEventoOperacao.codOperacao && this.resultado[i].versao === this.novoEventoOperacao.vrsOperacao) {
                        this.selecionaOperacao = this.resultado[i];
                    }
                }

                // this.eventoOperacaoAdiconado.emit(this.operacao);


                if (this.fta.fta != null || this.fta.fta != 0) {
                    setTimeout(() => {
                        if (this.evento.detalheEventoOperacao) {
                            this.recuperaParametroEdicao();
                        }
                    }, 1000);
                }

            }

        }
    }

    ngDoCheck() {
        if (this.novoEventoOperacao != undefined) {
            this.operacao = new EventoOperacao();
            this.operacao = this.novoEventoOperacao;
            // this.parmOperacao = this.novoEventoOperacao.parmOperacao
            //this.transmissaoAdicionada.emit(this.transmissao);
        }

        this.validaAddParametro();
    }


    salvarDadosOperacao() {
        if (this.evento.parametrosSelecionadosOperacao) {

            if (!this.evento.detalheEventoOperacao) {
                this.evento.detalheEventoOperacao = {...this.evento.detalheEventoOperacao, parmOperacao: []};
            } else {
                this.evento.detalheEventoOperacao.parmOperacao = [];
            }


            this.evento.detalheEventoOperacao.parmOperacao = [];

            this.evento.parametrosSelecionadosOperacao.reduce((ids: any, thing: any) => {
                if (thing.selecionado == true) {

                    if (thing.nomeSubtipoDado) {
                        var {
                            conteudoPadrao,
                            descricao,
                            nomeSubtipoDado,
                            nomeTipoDado,
                            obrigatorio,
                            parmConteudo,
                            parmNome,
                            selecionado
                        } = thing;

                        if (thing.nomeTipoDado != 'boolean' && (thing.nomeSubtipoDado == 'sel_excl' || thing.nomeSubtipoDado == 'sel_mult')) {
                            this.evento.detalheEventoOperacao.parmOperacao.push({
                                conteudoPadrao,
                                descricao,
                                nomeSubtipoDado,
                                nomeTipoDado,
                                obrigatorio,
                                'parmConteudo': conteudoPadrao,
                                parmNome,
                                selecionado
                            });
                        } else {
                            this.evento.detalheEventoOperacao.parmOperacao.push({
                                conteudoPadrao,
                                descricao,
                                nomeSubtipoDado,
                                nomeTipoDado,
                                obrigatorio,
                                'parmConteudo': parmConteudo,
                                parmNome,
                                selecionado
                            });
                        }

                        this.evento.listaParametrosSelecionadosOperacao = this.evento.detalheEventoOperacao.parmOperacao;
                        // this.eventoOperacaoAdiconado.emit(this.operacao);
                    }
                }
            }, []);
        }

        if (this.evento.detalheEventoOperacao) {
            this.evento.listaParametrosSelecionadosOperacao = this.evento.detalheEventoOperacao.parmOperacao;
            // this.eventoOperacaoAdiconado.emit(this.operacao);

            // this.eventoOperacaoAdiconado.emit(this.evento.detalheEventoOperacao)
        }

        this.eventoOperacaoAdiconado.emit(this.operacao);
    }

    validaAddParametro() {
        this.isDisabled = false;
        if (this.operacao != undefined) {
            if (this.operacao.parmOperacao != undefined) {

                let arrayParametros = [];
                for (let i in this.operacao.parmOperacao) {
                    arrayParametros.push(this.operacao.parmOperacao[i].parmNome);
                }

                let indexParametro = arrayParametros.indexOf(this.parmNome);

                if (indexParametro >= 0) {
                    if (this.operacao.parmOperacao[indexParametro].nomeSubtipoDado != 'array') {
                        if (this.operacao.parmOperacao[indexParametro].parmConteudo.length == 0) {
                            this.isDisabled = false;
                        } else {
                            this.isDisabled = true;
                        }
                    }
                } else {
                    this.isDisabled = false;
                }
            }
        }
        if (this.caracteresInvalidos.length > 0) {
            this.isDisabled = true;
        } else {
            this.isDisabled = false;
        }
    }

    finishFunction() {
        if (this.validacaoService.validaEvento(this.evento)) {
            this.eventoAlterado.emit(true);
            this.wizard.navigation.reset();
        }
    }

    cancelarEvento() {
        this.eventoCancelado.emit(this.evento);
    }

    recuperaParametroEdicao() {

        this.contador = 0;
        let filtros: Array<any> = new Array<any>();
        this.selecionado = new ParametroEntradaOperacao();
        this.eventoSelecionado = false;
        this.operacao.parmOperacao = [];
        this.listaParametroConteudo = [];

        this.ftaService.detalhaOperacao(this.selecionaOperacao.codigo, this.selecionaOperacao.versao)
            .subscribe(
                listaItens => {
                    if (listaItens != null) {
                        this.novaOperacao = listaItens;


                        // let parmEntradaAux = [];
                        // parmEntradaAux.push({conteudoPadrao: [],descricao: "",nome: "Selecione",nomeSubtipoDado: "",nomeTipoDado: "", obrigatorio: ""});
                        // for(let i in this.novaOperacao.parmEntrada){
                        //   parmEntradaAux.push(this.novaOperacao.parmEntrada[i])
                        // }
                        // parmEntradaAux = this.ordenarArray(parmEntradaAux);
                        // this.novaOperacao.parmEntrada = parmEntradaAux;
                        // this.loadingTablePrincipal = true;

                        var parametrosSelecionadoOperacao = [];

                        if (this.evento.listaParametrosSelecionadosOperacao) {
                            parametrosSelecionadoOperacao = this.evento.listaParametrosSelecionadosOperacao;

                        } else {
                            parametrosSelecionadoOperacao = this.novaOperacao.parmEntrada;
                        }


                        parametrosSelecionadoOperacao = parametrosSelecionadoOperacao.sort(function (a, b) {
                            return (a.parmNome > b.parmNome) ? 1 : ((b.parmNome > a.parmNome) ? -1 : 0);
                        });

                        this.evento.parametrosSelecionadosOperacao = [];


                        this.novaOperacao.parmEntrada.map((parmEntradaOperacaoComProduto: any) => {
                            var conteudoPadrao = [];

                            parmEntradaOperacaoComProduto.conteudoPadrao.map((valor, key) => {
                                conteudoPadrao.push({
                                    'selecionado': false,
                                    'nrPosicao': key,
                                    'conteudo': valor
                                });
                            });

                            if (Array.isArray(parametrosSelecionadoOperacao)) {
                                parametrosSelecionadoOperacao.map((parametrosSelecionadoOperacao: any) => {
                                    if (parametrosSelecionadoOperacao.parmNome == parmEntradaOperacaoComProduto.nome) {

                                        this.evento.parametrosSelecionadosOperacao[this.contador] = {
                                            'obrigatorio': parmEntradaOperacaoComProduto.obrigatorio,
                                            'selecionado': true,
                                            'parmNome': parmEntradaOperacaoComProduto.nome,
                                            'nomeTipoDado': parmEntradaOperacaoComProduto.nomeTipoDado,
                                            'nomeSubtipoDado': parmEntradaOperacaoComProduto.nomeSubtipoDado,
                                            'descricao': parmEntradaOperacaoComProduto.descricao,
                                            'conteudoPadrao': conteudoPadrao,
                                            'parmConteudo': []
                                        };

                                        parametrosSelecionadoOperacao.parmConteudo.map((parametroSelecionado, parametroSelecionadoKey) => {
                                            this.evento.parametrosSelecionadosOperacao[this.contador].parmConteudo.push({
                                                selecionado: true,
                                                conteudo: parametroSelecionado.conteudo,
                                                nrPosicao: parametroSelecionadoKey,
                                            });

                                            this.evento.parametrosSelecionadosOperacao[this.contador].conteudoPadrao.map((conteudoPadrao, conteudoPadraoKey) => {
                                                if (parametroSelecionado.conteudo == this.evento.parametrosSelecionadosOperacao[this.contador].conteudoPadrao[conteudoPadraoKey].conteudo) {
                                                    this.evento.parametrosSelecionadosOperacao[this.contador].conteudoPadrao[conteudoPadraoKey] = {
                                                        selecionado: true,
                                                        conteudo: parametroSelecionado.conteudo,
                                                        nrPosicao: parametroSelecionadoKey,
                                                    };
                                                }
                                            });
                                        });

                                    } else {
                                        if (Array.isArray(this.evento.parametrosSelecionadosOperacao)) {
                                            var validacaoExistente = this.evento.parametrosSelecionadosOperacao.reduce((key: any, parametrosSelecionadoValidacaoExistente: any) => {
                                                if (parametrosSelecionadoValidacaoExistente.parmNome == parmEntradaOperacaoComProduto.nome) {
                                                    return true;
                                                }
                                            }, '');

                                            if (validacaoExistente != true) {
                                                this.evento.parametrosSelecionadosOperacao[this.contador] = {
                                                    'obrigatorio': parmEntradaOperacaoComProduto.obrigatorio,
                                                    'selecionado': parmEntradaOperacaoComProduto.obrigatorio,
                                                    'parmNome': parmEntradaOperacaoComProduto.nome,
                                                    'nomeTipoDado': parmEntradaOperacaoComProduto.nomeTipoDado,
                                                    'nomeSubtipoDado': parmEntradaOperacaoComProduto.nomeSubtipoDado,
                                                    'descricao': parmEntradaOperacaoComProduto.descricao,
                                                    'conteudoPadrao': conteudoPadrao,
                                                    'parmConteudo': [
                                                        {
                                                            'selecionado': false,
                                                            'nrPosicao': 0,
                                                            'conteudo': null
                                                        },
                                                    ]
                                                };
                                            }
                                        }
                                    }
                                });
                            }

                            this.contador++;
                        });
                    }
                    this.salvarDadosOperacao();
                },
                erro => {
                    if (erro.status == 404) {
                        // erro
                    }
                }
            );

    }

    onChange() {
        this.contador = 0;
        let filtros: Array<any> = new Array<any>();
        this.selecionado = new ParametroEntradaOperacao();
        this.eventoSelecionado = false;
        this.operacao.parmOperacao = [];
        this.listaParametroConteudo = [];

        this.operacao.codOperacao = this.selecionaOperacao.codigo;
        this.operacao.vrsOperacao = this.selecionaOperacao.versao;

        this.ftaService.detalhaOperacao(this.selecionaOperacao.codigo, this.selecionaOperacao.versao)
            .subscribe(
                listaItens => {
                    if (listaItens != null) {
                        this.novaOperacao = listaItens;


                        // let parmEntradaAux = [];
                        // parmEntradaAux.push({conteudoPadrao: [],descricao: "",nome: "Selecione",nomeSubtipoDado: "",nomeTipoDado: "", obrigatorio: ""});
                        // for(let i in this.novaOperacao.parmEntrada){
                        //   parmEntradaAux.push(this.novaOperacao.parmEntrada[i])
                        // }
                        // parmEntradaAux = this.ordenarArray(parmEntradaAux);
                        // this.novaOperacao.parmEntrada = parmEntradaAux;
                        // this.loadingTablePrincipal = true;

                        var parametrosSelecionadoOperacao = [];


                        var parametrosSelecionadoOperacao = [];

                        parametrosSelecionadoOperacao = this.novaOperacao.parmEntrada;

                        parametrosSelecionadoOperacao = parametrosSelecionadoOperacao.sort(function (a, b) {
                            return (a.parmNome > b.parmNome) ? 1 : ((b.parmNome > a.parmNome) ? -1 : 0);
                        });

                        this.evento.parametrosSelecionadosOperacao = [];


                        this.novaOperacao.parmEntrada.map((parmEntradaOperacaoComProduto: any) => {
                            var conteudoPadrao = [];

                            parmEntradaOperacaoComProduto.conteudoPadrao.map((valor, key) => {
                                conteudoPadrao.push({
                                    'selecionado': false,
                                    'nrPosicao': key,
                                    'conteudo': valor
                                });
                            });

                            if (Array.isArray(parametrosSelecionadoOperacao)) {
                                parametrosSelecionadoOperacao.map((parametrosSelecionadoOperacao: any) => {
                                    if (parametrosSelecionadoOperacao.parmNome == parmEntradaOperacaoComProduto.nome) {

                                        this.evento.parametrosSelecionadosOperacao[this.contador] = {
                                            'obrigatorio': parmEntradaOperacaoComProduto.obrigatorio,
                                            'selecionado': true,
                                            'parmNome': parmEntradaOperacaoComProduto.nome,
                                            'nomeTipoDado': parmEntradaOperacaoComProduto.nomeTipoDado,
                                            'nomeSubtipoDado': parmEntradaOperacaoComProduto.nomeSubtipoDado,
                                            'descricao': parmEntradaOperacaoComProduto.descricao,
                                            'conteudoPadrao': conteudoPadrao,
                                            'parmConteudo': []
                                        };

                                        parametrosSelecionadoOperacao.parmConteudo.map((parametroSelecionado, parametroSelecionadoKey) => {
                                            this.evento.parametrosSelecionadosOperacao[this.contador].parmConteudo.push({
                                                selecionado: true,
                                                conteudo: parametroSelecionado.conteudo,
                                                nrPosicao: parametroSelecionadoKey,
                                            });

                                            this.evento.parametrosSelecionadosOperacao[this.contador].conteudoPadrao.map((conteudoPadrao, conteudoPadraoKey) => {
                                                if (parametroSelecionado.conteudo == this.evento.parametrosSelecionadosOperacao[this.contador].conteudoPadrao[conteudoPadraoKey].conteudo) {
                                                    this.evento.parametrosSelecionadosOperacao[this.contador].conteudoPadrao[conteudoPadraoKey] = {
                                                        selecionado: true,
                                                        conteudo: parametroSelecionado.conteudo,
                                                        nrPosicao: parametroSelecionadoKey,
                                                    };
                                                }
                                            });
                                        });

                                    } else {
                                        if (Array.isArray(this.evento.parametrosSelecionadosOperacao)) {
                                            var validacaoExistente = this.evento.parametrosSelecionadosOperacao.reduce((key: any, parametrosSelecionadoValidacaoExistente: any) => {
                                                if (parametrosSelecionadoValidacaoExistente.parmNome == parmEntradaOperacaoComProduto.nome) {
                                                    return true;
                                                }
                                            }, '');

                                            if (validacaoExistente != true) {
                                                this.evento.parametrosSelecionadosOperacao[this.contador] = {
                                                    'obrigatorio': parmEntradaOperacaoComProduto.obrigatorio,
                                                    'selecionado': parmEntradaOperacaoComProduto.obrigatorio,
                                                    'parmNome': parmEntradaOperacaoComProduto.nome,
                                                    'nomeTipoDado': parmEntradaOperacaoComProduto.nomeTipoDado,
                                                    'nomeSubtipoDado': parmEntradaOperacaoComProduto.nomeSubtipoDado,
                                                    'descricao': parmEntradaOperacaoComProduto.descricao,
                                                    'conteudoPadrao': conteudoPadrao,
                                                    'parmConteudo': [
                                                        {
                                                            'selecionado': false,
                                                            'nrPosicao': 0,
                                                            'conteudo': null
                                                        },
                                                    ]
                                                };
                                            }
                                        }
                                    }
                                });
                            }

                            this.contador++;
                        });
                    }

                },
                erro => {
                    if (erro.status == 404) {
                        // erro
                    }
                }
            );
    }

    //ordena array de paramentros
    ordenarArray(parmEntradaAux) {
        parmEntradaAux.sort(function (a, b) {
            if (a.nome < b.nome) {
                return -1;
            }
            if (a.nome > b.nome) {
                return 1;
            }
            return 0;
        });
        return parmEntradaAux;
    }

    validaCheckboxSelect(parametrosSelecionadoOperacao, conteudoSelecionado) {
        if (parametrosSelecionadoOperacao.nomeSubtipoDado == 'sel_excl' && parametrosSelecionadoOperacao.nomeTipoDado != 'boolean') {
            this.evento.parametrosSelecionadosOperacao.map((dados, key) => {
                if (dados.parmNome == parametrosSelecionadoOperacao.parmNome && this.evento.parametrosSelecionadosOperacao[key]) {
                    this.evento.parametrosSelecionadosOperacao[key].conteudoPadrao.map((dados, keyConteudo) => {

                        var {
                            selecionado,
                            nrPosicao,
                            conteudo
                        } = dados;

                        if (conteudoSelecionado.conteudo != this.evento.parametrosSelecionadosOperacao[key].conteudoPadrao[keyConteudo].conteudo) {
                            this.evento.parametrosSelecionadosOperacao[key].conteudoPadrao[keyConteudo] = {
                                selecionado: false,
                                nrPosicao,
                                conteudo
                            };
                        }
                    });
                }
            });
        }

        this.salvarDadosOperacao();
    }

    adicionarLinha(nome) {
        for (let i = 0; i <= this.evento.parametrosSelecionadosOperacao.length; i++) {
            if (this.evento.parametrosSelecionadosOperacao[i] && this.evento.parametrosSelecionadosOperacao[i].parmNome == nome) {
                if (this.evento.parametrosSelecionadosOperacao[i].parmConteudo) {
                    if (this.evento.parametrosSelecionadosOperacao[i].parmConteudo[this.evento.parametrosSelecionadosOperacao[i].parmConteudo.length - 1].conteudo) {
                        this.evento.parametrosSelecionadosOperacao[i].parmConteudo[this.evento.parametrosSelecionadosOperacao[i].parmConteudo.length] = {
                            'nrPosicao': this.evento.parametrosSelecionadosOperacao[i].parmConteudo.length++,
                            'conteudo': null
                        };
                    } else {
                        this.modalService.exibirMensagem('Alerta!.\n',
                            `Não é possível adicionar novos campos sem que preencha o campo anterior! `
                            , 'Fechar');
                    }
                }
            }
        }
    }

    msgAjuda(msg: any) {
        // this.clearMsgAjuda();

        this.modalService.exibirMensagem('Descrição do parâmetro.\n',
            `Tipo: ${msg.nomeTipoDado} <br> Subtipo: ${msg.nomeSubtipoDado} <br> Descrição: ${msg.descricao}`
            , 'Fechar');

    }

    msgAjudaParametro(msg: any) {
        // this.clearMsgAjuda();

        this.modalService.exibirMensagem('Descrição.\n',
            `${msg}`
            , 'Fechar');

    }

    selecionaParametro(event) {
        this.parmNome = event.value.nome;
        this.nomeSubtipoDado = event.value.nomeSubtipoDado;
        this.selecionado = event.value;
        this.eventoSelecionado = true;
        this.parametroConteudoArray = '';
        this.parametroConteudoTextoLivre = '';
        this.caracteresInvalidos = '';
        if (this.parmNome == 'arquivoOrigem' || this.parmNome == 'arquivoOrigemRegex' || this.parmNome == 'arquivoDestinoRegex') {
            this.validaCampo = true;
        } else {
            this.validaCampo = false;
        }
    }

    buscaDetalheOperacoes() {
    }

    onSubmit(f: NgForm) {
    }

    aoAdiconarConteudo() {

        this.listaParametroConteudo = [];

        let newParametro: ParametroConteudo = new ParametroConteudo();

        if (this.selecionado.nomeTipoDado != 'boolean' && (this.selecionado.nomeSubtipoDado == 'sel_excl' || this.selecionado.nomeSubtipoDado == 'sel_mult')) {
            newParametro.conteudo = this.parametroConteudoFixo;
        } else if (this.selecionado.nomeSubtipoDado == 'array') {
            newParametro.conteudo = this.parametroConteudoArray;
        } else {
            newParametro.conteudo = this.parametroConteudoTextoLivre;
        }

        this.listaParametroConteudo.push(newParametro);
        this.loadingConteudo = true;
        this.aoAdiconarParametro(newParametro);

        //this.messageService.addSuccessKey('Parâmetro e Conteúdo adicionado com sucesso.', this.chaveComposta);

        this.parametroConteudoFixo = '';
        this.parametroConteudoArray = '';
        this.parametroConteudoTextoLivre = '';
    }

    // Retorna um novo Parâmetro de transmissão
    aoAdiconarParametro(newParametro: ParametroConteudo) {

        this.loading = true;
        this.operacao.codOperacao = this.selecionaOperacao.codigo;
        this.operacao.vrsOperacao = this.selecionaOperacao.versao;

        let arrayParametros = [];
        for (let i in this.operacao.parmOperacao) {
            arrayParametros.push(this.operacao.parmOperacao[i].parmNome);
        }
        let indexParametro = arrayParametros.indexOf(this.parmNome);

        if (indexParametro >= 0) {
            newParametro.nrPosicao = this.operacao.parmOperacao[indexParametro].parmConteudo.length + 0;
            this.operacao.parmOperacao[indexParametro].parmConteudo.push(newParametro);
        } else {
            newParametro.nrPosicao = 0;
            this.parmOperacao = this.novoParametro(this.parmNome, this.listaParametroConteudo, this.nomeSubtipoDado);
            this.operacao.parmOperacao.push(this.parmOperacao);
        }

    }

    // Retorna um novo Parâmetro para os Eventos operação
    novoParametro(parmNome: string, conteudo: Array<ParametroConteudo>, nomeTipoDado: string): Parametro {
        let parmOperacao: Parametro = new Parametro();
        let parmConteudo: ParametroConteudo = new ParametroConteudo();
        parmOperacao.parmConteudo = new Array<ParametroConteudo>();
        parmOperacao.parmNome = parmNome;
        parmOperacao.nomeSubtipoDado = nomeTipoDado;
        //  parmConteudo.nrPosicao = 0;
        parmOperacao.parmConteudo = conteudo;
        return parmOperacao;
    }

    salvarOperacao() {
        if (this.operacao != null) {
            // this.eventoOperacaoAdiconado.emit(this.operacao);
            this.messageService.addSuccessKey('Operação adicionanda com sucesso.', this.chaveComposta);
        } else {
            this.messageService.addErrorKey('Operação não salva, algo inesperado ocorreu.', this.chaveComposta);
        }
    }

    remover(indice: any) {
        const index = this.operacao.parmOperacao.indexOf(indice);
        this.operacao.parmOperacao.splice(index, 1);
        if (this.operacao.parmOperacao.length === 0) {
            this.loading = false;
        }
    }

    validaCaracteresInvalidos(tipoCampo) {

        let str = '';

        if (tipoCampo == 'array') {
            str = this.parametroConteudoArray;
        } else {
            str = this.parametroConteudoTextoLivre;
        }

        this.caracteresInvalidos = '';
        let arrayInvalidos = '£¤¥¦§¨©ª«¬®¯°±²³µ¶·¸¹º»¼½¾¿:¡¢÷';
        for (var i = 0; i <= str.length; i++) {
            for (var j = 0; j < arrayInvalidos.length; j++) {
                if (str[i] == arrayInvalidos[j]) {
                    this.caracteresInvalidos += arrayInvalidos[j];
                }
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/detalhe-evento-operacao/detalhe-evento-operacao.component.ts